import { render, staticRenderFns } from "./BaseMain.vue?vue&type=template&id=2850169f&scoped=true&"
import script from "./BaseMain.vue?vue&type=script&lang=js&"
export * from "./BaseMain.vue?vue&type=script&lang=js&"
import style0 from "./BaseMain.vue?vue&type=style&index=0&id=2850169f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2850169f",
  null
  
)

export default component.exports